import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {environment} from '../../../../environments/environment';
import i18next from 'i18next';
import {SectionComponent} from "../../../shared/components/structure/section/section.component";
import {I18NextPipe} from "@kokos-i18next";
import {CheckboxComponent} from "../../../shared/components/controls/form-controls/checkbox/checkbox.component";
import {ValidationMessage} from "../../../shared/components/structure/validation-message/validation-message";
import {KinderLeistung} from "../../../core/model/kinder-leistung";

@Component({
    selector: 'kokos-kenntnisnahme',
    standalone: true,
    imports: [SectionComponent, I18NextPipe, CheckboxComponent, CheckboxComponent],
    templateUrl: './kenntnisnahme.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class KenntnisnahmeComponent implements OnInit {

    @Input() type!: KinderLeistung;
    @Input() validate: boolean;
    @Input() validationMessages: ValidationMessage[];

    childBenefitKey: string;
    leafletUrl: string;

    ngOnInit() {
        this.childBenefitKey = 'sendmail.form.kiwi.childbenefit-' + this.type.toLowerCase();
        this.leafletUrl = this.type === KinderLeistung.KINDERGELD
            ? environment.linkKindergeldInfo
            : environment.linkKinderZuschlagInfo;
    }

    get linkFamilyHtml(): string {
        const familyLabel = i18next.t('sendmail.form.kiwi.childbenefit-linklabel1');
        return `<a href="${environment.linkFamka}" target="_blank" rel="noopener noreferrer">${familyLabel}</a>`;
    }

    get linkPrivacyHtml(): string {
        const privacyLabel = i18next.t('sendmail.form.kiwi.childbenefit-linklabel2');
        return `<a href="${environment.linkHinweisDatenschutz}" target="_blank" rel="noopener noreferrer">${privacyLabel}</a>`;
    }

    get childBenefitType(): string {
        return i18next.t(this.childBenefitKey);
    }

    get linkLeafletHtml(): string {
        return `<a href="${this.leafletUrl}" target="_blank" rel="noopener noreferrer">${this.childBenefitType}</a>`;
    }
}